export const mainPageDescriptions = {
  univerzita: "Proč studovat UTB? Důvodů je mnoho!  ",
  studium: "Vyber si svoju fakultu",
  mesto: "Naše milované cihlové město. Proč je tak super?",
  navstivNas: "Přijď se k nám podívat. Dveře jsou otevřené.",
};

export const facultyTitles = {
  "fakulta-technologicka": "Fakulta technologická",
  "fakulta-managementu-a-ekonomiky": "Fakulta managementu a ekonomiky",
  "fakulta-multimedialnich-komunikaci": "Fakulta multimediálních komunikací",
  "fakulta-aplikovane-informatiky": "Fakulta aplikované informatiky",
  "fakulta-humanitnich-studii": "Fakulta humanitních studií",
  "fakulta-logistiky-a-krizoveho-rizeni":
    "Fakulta logistiky a krizového řízení",
  "univerzitni-institut": "Univerzitní institut",
};

export const facultyDescriptions = {
  "fakulta-technologicka":
    "Už od malička jste chtěli věcem přijít na kloub, zjistit jak fungují a z čeho jsou? Pak je FT ta správná volba.",
  "fakulta-managementu-a-ekonomiky":
    "Život ekonoma nejsou jen čísla a tabulky, na FaME se naučíte propojit ekonomické teorie s manažerskou praxí.",
  "fakulta-multimedialnich-komunikaci":
    "Jste kreativní, láká vás umění, design, film, animace, fotky či marketing? Pak je FMK stvořená přímo pro vás!",
  "fakulta-aplikovane-informatiky":
    "Studujte informační technologie — obory budoucnosti — pod vedením odborníků ve špičkově vybavených laboratořích.",
  "fakulta-humanitnich-studii":
    "Na techniku vás neužije, máte raději lidi a společnost? Studujte jazyky, pedagogiku nebo se staňte zdravotní sestrou.",
  "fakulta-logistiky-a-krizoveho-rizeni":
    "Zjistěte, co obnáší práce hasičů, policistů, záchranářů, jak řídit velké projekty nebo třeba celou jadernou elektrárnu.",
  "univerzitni-institut":
    "Milujete vědu a nestačí vám titul Ing.? Zkoumejte biomateriály nebo nanotechnologie v naší profi výzkumné jednotce.",
};

export const facultyImages = {
  "fakulta-technologicka": "/img/ft-study.jpg",
  "fakulta-managementu-a-ekonomiky": "/img/fame_study_2.jpg",
  "fakulta-multimedialnich-komunikaci": "/img/fmk-study.jpg",
  "fakulta-aplikovane-informatiky": "/img/fai-study.jpg",
  "fakulta-humanitnich-studii": "/img/fhs-study.jpg",
  "fakulta-logistiky-a-krizoveho-rizeni": "/img/flkr-study.jpg",
  "univerzitni-institut": "/img/uni-study.jpg",
};
